export default "__VITE_ASSET__Dd2N$nbC__"